import { Injectable } from '@angular/core';
import { BehaviorSubject, map } from 'rxjs';

interface ScreenSize {
	width: number;
	height: number;
}

const PLAYER_SMALL_SIZE_THRESHOLD = 768;

//Widths at which the icons change
const breakpoints = [443, 369, 307, 259, 231, 209, 169];

@Injectable()
export class PlayerSizeDetectionService {
	public screenSizeSubject$ = new BehaviorSubject<ScreenSize>({ width: 0, height: 0 });
	public playerIconPriority$ = this.screenSizeSubject$.asObservable().pipe(map(size => this.getPlayerIconPriority(size.width)));
	public isSmallSizePlayer = false;

	public setPlayerSize(width: number, height: number): void {
		this.screenSizeSubject$.next({ width, height });
		this.isSmallSizePlayer = width < PLAYER_SMALL_SIZE_THRESHOLD && width !== 0;
	}

	private getPlayerIconPriority(playerWidth: number): number {
		if (!playerWidth) {
			return breakpoints.length;
		}

		const index = breakpoints.findIndex(breakpoint => breakpoint < playerWidth);
		return index < 0 ? breakpoints.length : index;
	}
}
